import React, { useMemo } from "react";

// 1) Helpers

function randomTagBg() {
  const h = Math.floor(Math.random() * 360);
  const s = 60 + Math.random() * 20; // 60–80% saturation
  const l = 40 + Math.random() * 20; // 40–60% lightness
  return { h, s, l };
}

function hslToRgb(h, s, l) {
  const hue2rgb = (p, q, t) => {
    if (t < 0) t += 1;
    if (t > 1) t -= 1;
    if (t < 1/6) return p + (q - p) * 6 * t;
    if (t < 1/2) return q;
    if (t < 2/3) return p + (q - p) * (2/3 - t) * 6;
    return p;
  };
  h = h / 360; s = s / 100; l = l / 100;
  const q = l < 0.5 ? l * (1 + s) : l + s - l * s;
  const p = 2 * l - q;
  const r = hue2rgb(p, q, h + 1/3);
  const g = hue2rgb(p, q, h);
  const b = hue2rgb(p, q, h - 1/3);
  return [Math.round(r * 255), Math.round(g * 255), Math.round(b * 255)];
}

function getContrastColor([r, g, b]) {
  const brightness = (r * 299 + g * 587 + b * 114) / 1000;
  return brightness > 128 ? "#000" : "#fff";
}

// 2) Market-cap classifier
function classifyMarketCap(marketCap) {
  console.log("Market Cap:", marketCap);
  if (marketCap >= 200_000) return "Mega Cap";
  if (marketCap >= 10_000)  return "Large Cap";
  if (marketCap >= 2_000)   return "Mid Cap";
  if (marketCap >= 300)     return "Small Cap";
  return "Micro Cap";
}

export default function TagPills({
  sector,
  industryA,
  hasETF,
  marketCap,        // new prop
}) {
  const tagStyles = useMemo(() => {
    const tags = [];
    if (sector && sector !== "-")    tags.push(sector);
    if (industryA && industryA !== "-") tags.push(industryA);
    if (hasETF)                        tags.push("ETF");
    if (typeof marketCap === "number") {
      tags.push(classifyMarketCap(marketCap));
    }

    return tags.map(text => {
      const { h, s, l } = randomTagBg();
      const bgHsl = `hsl(${h},${s.toFixed(0)}%,${l.toFixed(0)}%)`;
      const [r, g, b] = hslToRgb(h, s, l);
      const fg = getContrastColor([r, g, b]);
      return { text, bg: bgHsl, fg };
    });
  }, [sector, industryA, hasETF, marketCap]);

  return (
    <div
      className="tags-container"
      style={{
        display: "flex",
        overflowX: "auto",
        gap: "8px",
        whiteSpace: "nowrap",
        padding: "8px 0",
        marginLeft: 20
      }}
    >
      {tagStyles.map(({ text, bg, fg }) => (
        <span
          key={text}
          className="tags"
          style={{
            backgroundColor: bg,
            color: fg,
          }}
        >
          {text}
        </span>
      ))}
    </div>
  );
}
